import { Routes, Route, Navigate } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import Login from "./login/Login";
import Register from "./register/Register";
import ForgotPassword from "./forgot-password/ForgotPassword";

import MainLayout from "../layouts/MainLayout";
import ProtectedRoute from "../components/ProtectedRoute";
import PublicRoute from "../components/PublicRoute";
import FullScreenLoader from "../components/FullScreenLoader";
import { getLandingPath } from "../utils/landing-path";
import NotFound from "../modules/swiftboard/not-found/page";
import YourAccountCompt from "../modules/swiftboard/your-account/page";
import LoginSecurityCompt from "../modules/swiftboard/login-security/page";
import SettingsCompt from "../modules/swiftboard/settings/page";

// Role-based pages: each entry file picks the page for the user's role
import Home from "modules/swiftboard/home/Home";
import Overview from "modules/swiftboard/overview/Overview";
import LiveProjects from "modules/swiftboard/live-projects/LiveProjects";
import ProjectHistory from "modules/swiftboard/project-history/ProjectHistory";
import EmployeeManagement from "modules/swiftboard/employee-management/EmployeeManagement";

import StandaloneChatPage from "../modules/swiftboard/live-projects/conversation/page";

import ModuleRouteGuard from "components/ModuleRouteGuard";
import BusinessDirectory from "modules/swiftboard/central-directories/business-directories/BusinessDirectory";
import SystemDirectory from "modules/swiftboard/central-directories/system-directories/SystemDirectory";
import UserManagement from "modules/swiftboard/user-role-module/user-management/UserManagement";
import UserActivity from "modules/swiftboard/user-role-module/user-activity-security/UserActivity";
import Roles from "modules/swiftboard/user-role-module/role-and-permissions/Roles";
import Companies from "modules/swiftboard/company-management/Companies";
import ApprovalNotifications from "modules/swiftboard/approval-notifications/ApprovalNotifications";
import EmailSettings from "modules/swiftboard/email-management/email-settings/EmailSettings";
import Activities from "modules/swiftboard/email-management/activities/Activities";
import EmailDashboard from "modules/swiftboard/email-management/email-dashboard/EmailDashboard";
import EmailTemplate from "modules/swiftboard/email-management/email-template/EmailTemplate";
import Campaigns from "modules/swiftboard/email-management/campaigns/Campaigns";
import AiAssistantPage from "modules/swiftboard/ai-assistant/page";

import ReminderSetup from "modules/swiftboard/reminder-builder/reminder-setup/ReminderSetup";
import ReminderLibrary from "modules/swiftboard/reminder-builder/reminder-library/ReminderLibrary";
import ReminderDesigner from "modules/swiftboard/reminder-builder/reminder-designer/ReminderDesigner";
import ReminderMonitor from "modules/swiftboard/reminder-builder/reminder-monitor/ReminderMonitor";

import KnowLedgeConfiguration from "modules/swiftboard/knowledge-management/knowledge-configuration/KnowLedgeConfiguration";
import KnowledgeBase from "modules/swiftboard/knowledge-base/KnowledgeBase";
import ArticleView from "modules/swiftboard/knowledge-base/ArticleView";
import ChapterView from "modules/swiftboard/knowledge-base/ChapterView";
import { EstimateRoutes, EstimateSettingsRoutes } from "modules/swiftboard/estimate/routes"; // PROTOTYPE – Estimate Engine (mock data)

function RootRedirect() {
  const { user, loading, allowedPaths } = useContext(AuthContext);
  if (loading) return <FullScreenLoader />;
  if (user) return <Navigate to={getLandingPath(user, allowedPaths)} />;
  return <Navigate to="/login" />;
} 


export default function App() {
  return (
    <Routes>
      <Route path="*" element={<RootRedirect />} />
      <Route path="/login" element={<PublicRoute> <Login /> </PublicRoute>} />
      <Route path="/register" element={<PublicRoute> <Register /> </PublicRoute>} />
      <Route path="/forgot-password" element={<PublicRoute> <ForgotPassword /> </PublicRoute>} />

      {/* Full-screen standalone chat (no app shell) — opens in its own tab */}
      <Route
        path="/swiftboard/live-projects/conversation/:chatType"
        element={<ProtectedRoute> <StandaloneChatPage /> </ProtectedRoute>}
      />

      <Route path="/swiftboard" element={<ProtectedRoute> <MainLayout /> </ProtectedRoute>}>
        <Route index element={<Navigate to="home" />} />   {/* AUTO REDIRECT WHEN ONLY /swiftboard */}
        <Route element={<ModuleRouteGuard />}>    {/* Ye guard modules ke access ko control krega ki kon se Role ke based pr kon se modules ka Access allowed hai */}
          <Route path="employee-management" element={<EmployeeManagement />} /> {/*ADMIN only*/}
          <Route path="overview" element={<Overview />} />
          <Route path="live-projects/*" element={<LiveProjects />} />
          <Route path="project-history" element={<ProjectHistory />} />
          <Route path="login-security" element={<LoginSecurityCompt />} />
          <Route path="home" element={<Home />} />    {/* Home role ke based pr decide krega ki konsa page (component) dikana hai. Naye role ko DefaultHome dikhega. */}
          <Route path="your-account" element={<YourAccountCompt />} /> {/*Jis Jis Role ko assign hoga sabko same UI page (component) dikhegi */}
          <Route path="settings" element={<SettingsCompt />} />
          <Route path="central-directories/business-directories" element={<BusinessDirectory />} />
          <Route path="central-directories/system-directories" element={<SystemDirectory />} />
          <Route path="user-role-module/user-management" element={<UserManagement />} />
          <Route path="user-role-module/user-activity-security" element={<UserActivity />} />
          <Route path="user-role-module/roles" element={<Roles />} />

          <Route path="companies" element={<Companies />} />
          <Route path="approval-notifications" element={<ApprovalNotifications />} />

          <Route path="email-management/email-dashboard" element={<EmailDashboard />} />
          <Route path="email-management/email-settings" element={<EmailSettings />} />
          <Route path="email-management/email-template" element={<EmailTemplate />} />
          <Route path="email-management/campaigns" element={<Campaigns />} />
          <Route path="email-management/activities" element={<Activities/>} />
          <Route path="ai-assistant" element={<AiAssistantPage />} />

          <Route path="reminder-builder/reminder-setup" element={<ReminderSetup />} />
          <Route path="reminder-builder/reminder-library" element={<ReminderLibrary />} />
          <Route path="reminder-builder/reminder-designer" element={<ReminderDesigner />} />
          <Route path="reminder-builder/reminder-monitor" element={<ReminderMonitor />} />
 
          <Route path="knowledge-management/knowledge-configuration" element={<KnowLedgeConfiguration />} />
          {/* <Route path="knowledge-management/knowledge-configuration" element={<div className="text-text" >abc</div>} /> */}
          <Route path="knowledge-base" element={<KnowledgeBase />} /> {/*Jis Jis Role ko assign hoga sabko same UI page (component) dikhegi*/}
          <Route path="knowledge-base/chapter/:chapterId" element={<ChapterView />} />
          <Route path="knowledge-base/:articleId" element={<ArticleView />} />

          {/* PROTOTYPE – Estimate Engine (mock data). Needs module_master rows for both paths. */}
          <Route path="estimates/*" element={<EstimateRoutes />} />
          <Route path="estimate-settings/*" element={<EstimateSettingsRoutes />} />
        </Route>
        <Route path="*" element={<NotFound />} /> 
      </Route>
    </Routes>
  );
}




